import React from 'react';
import { Progress, Tooltip } from 'antd';
import { ClockIcon } from 'icons';
import { useRouter } from 'next/router';

import { globalConst, parseSubjectName, slugify, useCountdownTimer } from 'modules/global';

interface IProps {
  id?: number;
  type: string;
  time?: number;
  progress?: number;
  hour?: number;
  shablonName?: string;
  lessonName?: string;
  subjectName?: string;
}

const UnFinishedTestsCard = ({ type, time, progress, lessonName, subjectName, id }: IProps) => {
  const { remaining } = useCountdownTimer({ startTime: time });
  const { push } = useRouter();

  const handleClick = () => {
    const slug = slugify(lessonName || '');

    if (type === 'DTM') {
      push(globalConst.pageNames.DTM_TEST);
    } else if (type === 'Virtual') {
      push(globalConst.pageNames.VIRTUAL_TEST);
    } else if (type === 'Mavzuli' && subjectName && id) {
      push(`${globalConst.pageNames.TOPIC_TEST}/${parseSubjectName(subjectName)?.toLowerCase()}/${id}-${slug}`);
    }
  };

  return (
    <div
      onClick={handleClick}
      className="min-h-40 max-h-40 flex cursor-pointer flex-col justify-between rounded-xl bg-white p-3"
    >
      <div className="flex items-center gap-2">
        <div>
          <Progress type="dashboard" size={32} strokeColor="#12B76A" percent={progress} />
        </div>
        <div className="text-green-500 text-xs">{type}</div>
      </div>
      {lessonName && lessonName.length > 30 ? (
        <Tooltip title={lessonName}>
          <h1 className="mt-4 line-clamp-2 font-medium text-[0.813rem] text-gray-800">{lessonName}</h1>
        </Tooltip>
      ) : (
        <h1 className="mt-4 line-clamp-2 font-medium text-gray-800">{lessonName}</h1>
      )}
      <div className="mt-auto">
        {type === 'Mavzuli' ? (
          <div className="line-clamp-1 inline-flex items-center gap-1 rounded-full bg-sky-50 px-2 text-sm font-medium text-blue-900">
            {subjectName}
          </div>
        ) : (
          <div className="inline-flex items-center gap-1 rounded-full bg-red-50 px-2 text-sm font-medium text-red-500">
            <ClockIcon /> {remaining}
          </div>
        )}
      </div>
    </div>
  );
};

export default UnFinishedTestsCard;
